import type { FC } from 'react';

import type { CircularProgressProps } from '@mui/material/CircularProgress';
import CircularProgress from '@mui/material/CircularProgress';

const AtpCircularProgress: FC<CircularProgressProps> = (props) => {
  const { size = 24, ...rest } = props;
  return <CircularProgress {...rest} size={size} />;
};

export default AtpCircularProgress;
